import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function BrushIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 18 18" {...props}>
			<path
				d="M5.97931 9.625C6.72138 7.65989 7.98024 5.93158 9.623 4.62251C11.2658 3.31344 13.2315 2.47217 15.3126 2.1875C15.028 4.26867 14.1864 6.23439 12.8773 7.87715C11.5683 9.5199 9.83997 10.7788 7.87486 11.5208M7.72924 6.5625C9.14613 7.21647 10.2836 8.35394 10.9376 9.77083M2.1875 15.3125V12.3958C2.1875 11.819 2.35856 11.2551 2.67905 10.7754C2.99953 10.2958 3.45506 9.92194 3.98801 9.70119C4.52096 9.48043 5.1074 9.42267 5.67318 9.53521C6.23896 9.64775 6.75866 9.92554 7.16656 10.3334C7.57446 10.7413 7.85225 11.261 7.96479 11.8268C8.07733 12.3926 8.01957 12.979 7.79882 13.512C7.57806 14.0449 7.20422 14.5005 6.72458 14.821C6.24494 15.1414 5.68103 15.3125 5.10417 15.3125H2.1875Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIcon>
	);
}

export default BrushIcon;
